import { render, staticRenderFns } from "./reportOrgConsignment.vue?vue&type=template&id=e5af51d8&scoped=true&"
import script from "./reportOrgConsignment.vue?vue&type=script&lang=js&"
export * from "./reportOrgConsignment.vue?vue&type=script&lang=js&"
import style0 from "./reportOrgConsignment.vue?vue&type=style&index=0&id=e5af51d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5af51d8",
  null
  
)

export default component.exports